import { Element } from "@easy-email-pro-core/typings";
import React, { useContext } from "react";

export interface WrapperElementContextProps {
  element: Element | null;
}

const WrapperElementContext = React.createContext<WrapperElementContextProps>(
  {} as any
);

export const useWrapperElementContext = () => {
  return useContext(WrapperElementContext);
};

export const WrapperElementProvider: React.FC<
  WrapperElementContextProps & { children: React.ReactNode }
> = (props) => {
  return (
    <WrapperElementContext.Provider value={props}>
      {props.children}
    </WrapperElementContext.Provider>
  );
};
